export default "__VITE_ASSET__9nOA_1we__"